import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
  standalone: false,
})
export class SecurityComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
